import axios from "axios";

import { ZipCloudResponse } from "../../types/common";
import axiosInstance, { axiosInstanceCommon } from "../axios";

// Get items
export async function getItems(
  keyword?: string,
  prefecture?: string,
  is_general?: boolean,
  is_japanese_student?: boolean,
  is_international_student?: boolean,
  is_welfare_recipient?: boolean,
  is_business?: boolean,
  item_type?: boolean
) {
  const params = {
    keyword,
    prefecture,
    is_general,
    is_japanese_student,
    is_international_student,
    is_welfare_recipient,
    is_business,
    item_type,
    order: "item_code"
  };
  const response = await axiosInstanceCommon.get("/items", { params });
  return response.data.data;
}

// Get address by zipcode
export async function getAddressByZipcode(zipcode: string) {
  const response = await axios.get<ZipCloudResponse>(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`);
  return response.data;
}

// Get me
export async function getMe() {
  const response = await axiosInstance.get("/me");
  return response.data.data;
}

// Search dashboard
export async function searchDashboard(page: number, per_page: number, keyword: string) {
  const response = await axiosInstance.get("/search", { params: { page, per_page, keyword } });
  return response.data;
}
